import { render, staticRenderFns } from "./PitchGroupShow.vue?vue&type=template&id=447ffc0e"
import script from "./PitchGroupShow.vue?vue&type=script&lang=js"
export * from "./PitchGroupShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports